/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".template1[_ngcontent-%COMP%]   .text-decoration-none[_ngcontent-%COMP%]{text-decoration:none!important}.template1[_ngcontent-%COMP%]   .related-products[_ngcontent-%COMP%]   .main-heading[_ngcontent-%COMP%]{font-family:helvetica-bold,Roboto-bold!important;font-size:24px}"];
export { styles as styles };
